// extracted by mini-css-extract-plugin
module.exports = {"contactContainer":"ContactsModal_contactContainer__36plf","contact":"ContactsModal_contact__PXu1n","notes":"ContactsModal_notes__1w8pM"};